import { render, staticRenderFns } from "./ContactEdit.vue?vue&type=template&id=3978639a&scoped=true"
import script from "./ContactEdit.vue?vue&type=script&lang=ts"
export * from "./ContactEdit.vue?vue&type=script&lang=ts"
import style0 from "./ContactEdit.vue?vue&type=style&index=0&id=3978639a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3978639a",
  null
  
)

export default component.exports